import * as Actions from 'reducks/category/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const CategoryReducer = (state = initialState.category, action: any) => {
  switch (action.type) {
    case Actions.FETCH_CATEGORIES:
      return {
        ...state,
        categories: [...action.payload],
      }
    default:
      return state
  }
}
